// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AxRIU","index":"styles_index__MROIU"};